import React from "react";

export const Navigation = (props) => {
  const modifyHref = (href) => {
    if (window.location.pathname === '/products') {
      return `./${href}`;
    }
    return href;
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll logo" href={modifyHref("#page-top")}>
            <img src="img/logo1.png" alt="" className="ml-2" />
            <span>Papel Refil</span>
          </a>
        </div>
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href={modifyHref("#features")} className="page-scroll">
                Características
              </a>
            </li>
            <li>
              <a href={modifyHref("#about")} className="page-scroll">
                Sobre
              </a>
            </li>
            <li>
              <a href={modifyHref("#services")} className="page-scroll">
                Produtos
              </a>
            </li>
            <li>
              <a href={modifyHref("#testimonials")} className="page-scroll">
                Depoimentos
              </a>
            </li>
            <li>
              <a href={modifyHref("#contact")} className="page-scroll">
                Contato
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
